import React from "react"
import { NormalField } from "reactstrap-form-fields"
import Button from "./btn"

let Form = () => (
  <form name="Contact Form" method="POST" action="https://www.flexyform.com/f/19853db9e6296d1097f0a93d097ea0e58b347b33" netlify="true" data-netlify="true">
    <input type="hidden" name="form-name" value="Contact Form" />
    <NormalField name="Full Name" />
    <NormalField name="Email" />
    <NormalField name="Company/Organization" required={false} />
    <NormalField name="How can we help you?" type="textarea" />
      <Button type="submit" style={{background:'rgba(255,129,79,1)'}}>Submit</Button>
  </form>
)

export default Form
